export const maintenanceStyleOnlyTags = new Set([
  'BR',
  'LI',
  'B',
  'I',
  'TBODY',
  'THEAD',
  'H1',
  'H2',
  'H3',
  'DIV',
  'SPAN',
  'P',
  'LABEL',
  'STRONG',
  'UL',
  'OL',
  'EM',
  'H4',
  'TR',
])

export function sanitizeHtml(html: string): string {
  const output = document.createElement('template')
  const source = document.createElement('template')
  source.innerHTML = html

  for (const child of Array.from(source.content.childNodes)) {
    sanitizeMaintenanceNode(child, output.content)
  }

  return output.innerHTML
}

export function sanitizeMaintenanceNode(inputNode: Node | null, outputParent: Node): void {
  if (inputNode == null) return

  if (inputNode.nodeType === Node.TEXT_NODE) {
    outputParent.appendChild(document.createTextNode(inputNode.nodeValue ?? ''))
    return
  }

  if (inputNode.nodeType !== Node.ELEMENT_NODE) return

  const inputElement = inputNode as HTMLElement
  const tagName = inputElement.tagName
  const outputElement = document.createElement(tagName)

  if (tagName === 'A') {
    const inputLink = inputElement as HTMLAnchorElement
    if (inputLink.host !== '') {
      outputElement.setAttribute('href', inputLink.href)
    }
    outputElement.setAttribute('target', '_blank')
    outputElement.setAttribute('rel', 'noopener')
  } else if (tagName === 'IMG') {
    copyMaintenanceAttributes(outputElement, inputElement, ['src', 'width', 'height', 'class'])
  } else if (maintenanceStyleOnlyTags.has(tagName)) {
    copyMaintenanceAttributes(outputElement, inputElement, ['style'])
  } else if (tagName === 'TABLE') {
    copyMaintenanceAttributes(outputElement, inputElement, ['style', 'border'])
  } else if (tagName === 'TD' || tagName === 'TH') {
    copyMaintenanceAttributes(outputElement, inputElement, ['style', 'colspan', 'rowspan'])
  } else {
    return
  }

  outputParent.appendChild(outputElement)
  for (const child of Array.from(inputElement.childNodes)) {
    sanitizeMaintenanceNode(child, outputElement)
  }
}

export function copyMaintenanceAttributes(
  outputElement: HTMLElement,
  inputElement: HTMLElement,
  attributeNames: string[],
): void {
  for (const attributeName of attributeNames) {
    if (inputElement.hasAttribute(attributeName)) {
      outputElement.setAttribute(attributeName, inputElement.getAttribute(attributeName) ?? '')
    }
  }
}
